import {ActivatedRouteSnapshot, Resolve} from '@angular/router';
import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {RouteHelperService} from '../services/route-helper.service';

@Injectable({
  providedIn: 'root'
})
// default page resolver that fetches data from the API based on the current route
export class DefaultPageResolver<T> implements Resolve<T> {
  constructor(private readonly routeHelperService: RouteHelperService,
              private readonly httpClient: HttpClient
  ) {
  }

  resolve(route: ActivatedRouteSnapshot) {
    const urlPartToRemove = route.data['urlPartToRemove'] as string;

    if (urlPartToRemove) {
      return this.resolveWithoutUrlPart(this.routeHelperService.getApiUrlBasedOnActivatedRouteSnapshot(route), urlPartToRemove);
    } else {
      return this.resolveByUrl(this.routeHelperService.getApiUrlBasedOnActivatedRouteSnapshot(route));
    }
  }

  resolveWithoutUrlPart(url: string, urlPartToRemove: string) {
    if (!urlPartToRemove) {
      throw new Error('No urlPartToRemove provided in route data');
    }

    return this.resolveByUrl(url.replace(urlPartToRemove, ''));
  }

  resolveByUrl(url: string | URL) {
    let requestUrl: URL;
    try {
      requestUrl = new URL(url);
    } catch {
      // Fallback when the provided URL is only relative -> Request will be sent to current location.href
      requestUrl = new URL(url, window.location.origin);
    }
    return this.httpClient.get<T>(requestUrl.href);
  }
}
